/**
 * The scroll behavior to pass to scrollIntoView: smooth, unless the user
 * has asked the system for reduced motion.
 */
export default function scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';
}
